<template>
  <div class="linkToolsWorkspace">
    <div class="linkToolsWorkspace__shell">
      <header class="linkToolsWorkspace__header">
        <div>
          <h1 class="linkToolsWorkspace__title">清缓存</h1>
          <p class="linkToolsWorkspace__hint">按类型清理 Redis 缓存</p>
        </div>
      </header>

      <div class="linkToolsWorkspace__body">
        <div class="linkToolsGrid">
          <section class="linkToolsCard">
            <div class="linkToolsCard__head">
              <h2 class="linkToolsCard__title">清通用缓存</h2>
              <p class="linkToolsCard__hint">清除全局通用 Redis 缓存，操作后立即生效</p>
            </div>
            <div class="linkToolsCard__body">
              <button
                type="button"
                class="linkToolsClearBtn linkToolsClearBtn--standalone"
                @click="clearRedis"
              >
                <i class="el-icon-refresh-right" aria-hidden="true" />
                <span>清缓存</span>
              </button>
            </div>
          </section>

          <section class="linkToolsCard">
            <div class="linkToolsCard__head">
              <h2 class="linkToolsCard__title">清 Wallpaper Page 页缓存</h2>
              <p class="linkToolsCard__hint">按 App 清理 Page 页缓存，约 5 分钟内完成</p>
            </div>
            <div class="linkToolsCard__body">
              <div class="linkToolsFieldRow">
                <el-select
                  v-model="value"
                  class="linkToolsFieldRow__input"
                  filterable
                  remote
                  placeholder="请选择 App"
                  size="small"
                  :loading="loading"
                  clearable
                  :remote-method="(q) => remoteMethod(q, 'wallpaper')"
                  @clear="appNamePageOption = appNamePage"
                >
                  <el-option
                    v-for="item in appNamePageOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.appKey"
                  />
                </el-select>
                <button
                  type="button"
                  class="linkToolsClearBtn"
                  @click="clearPage('wallpaper')"
                >
                  <i class="el-icon-refresh-right" aria-hidden="true" />
                  <span>清缓存</span>
                </button>
              </div>
            </div>
          </section>

          <section class="linkToolsCard">
            <div class="linkToolsCard__head">
              <h2 class="linkToolsCard__title">清 Category 缓存</h2>
              <p class="linkToolsCard__hint">按 App 清理分类缓存，约 5 分钟内完成</p>
            </div>
            <div class="linkToolsCard__body">
              <div class="linkToolsFieldRow">
                <el-select
                  v-model="value_category"
                  class="linkToolsFieldRow__input"
                  filterable
                  remote
                  placeholder="请选择 App"
                  size="small"
                  :loading="loading"
                  clearable
                  :remote-method="(q) => remoteMethod(q, 'category')"
                  @clear="categoryNamePageOption = appNamePage"
                >
                  <el-option
                    v-for="item in categoryNamePageOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.appKey"
                  />
                </el-select>
                <button
                  type="button"
                  class="linkToolsClearBtn"
                  @click="clearPage('category')"
                >
                  <i class="el-icon-refresh-right" aria-hidden="true" />
                  <span>清缓存</span>
                </button>
              </div>
            </div>
          </section>

          <section class="linkToolsCard">
            <div class="linkToolsCard__head">
              <h2 class="linkToolsCard__title">按资源 Key 删缓存</h2>
              <p class="linkToolsCard__hint">输入 resourceKey，精确删除对应资源缓存</p>
            </div>
            <div class="linkToolsCard__body">
              <div class="linkToolsFieldRow">
                <el-input
                  v-model="resourceKey"
                  class="linkToolsFieldRow__input"
                  size="small"
                  placeholder="请输入 resourceKey"
                  clearable
                  @keydown.enter.native="clearPage('resourceKey')"
                />
                <button
                  type="button"
                  class="linkToolsClearBtn"
                  @click="clearPage('resourceKey')"
                >
                  <i class="el-icon-refresh-right" aria-hidden="true" />
                  <span>清缓存</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <like />
  </div>
</template>

<script>
import {
  refreshPage,
  getaAllRelationApp,
  refreshPageResponse,
  refreshCategoryResponse,
  refreshResourceKeyResponse,
} from '../../../api/utoolsManage'
import like from '../../../components/lottie/like.vue'

export default {
  name: 'clearRedis',
  components: {
    like,
  },
  data() {
    this.appNamePage = []
    return {
      value: '',
      appNamePageOption: [],
      loading: false,
      value_category: '',
      categoryNamePageOption: [],
      resourceKey: '',
    }
  },
  created() {
    this.getOption()
  },
  methods: {
    clearRedis() {
      refreshPage()
        .then(() => {
          this.$message({
            type: 'success',
            message: '缓存清除成功',
          })
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
          })
        })
    },
    remoteMethod(query, name) {
      if (query !== '') {
        this.loading = true
        const pattern = RegExp(`^${query}`, 'i')
        const newData = this.appNamePage.filter((item) => pattern.test(item.name))
        if (name === 'wallpaper') {
          this.appNamePageOption = newData
        } else {
          this.categoryNamePageOption = newData
        }
        this.loading = false
      } else if (name === 'wallpaper') {
        this.appNamePageOption = this.appNamePage
      } else {
        this.categoryNamePageOption = this.appNamePage
      }
    },
    getOption() {
      getaAllRelationApp().then((res) => {
        const data = JSON.parse(JSON.stringify(res.data))
        this.appNamePage = data
        this.appNamePageOption = data
        this.categoryNamePageOption = data
      })
    },
    clearPage(name) {
      if (name === 'wallpaper') {
        if (!this.value) {
          this.$message({
            type: 'info',
            message: 'wallpaper 选项不能为空～',
          })
          return
        }
        refreshPageResponse(this.value).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '清除缓存成功～',
            })
          }
        })
      } else if (name === 'category') {
        if (!this.value_category) {
          this.$message({
            type: 'info',
            message: 'category 选项不能为空～',
          })
          return
        }
        refreshCategoryResponse(this.value_category).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '清除缓存成功～',
            })
          }
        })
      } else if (name === 'resourceKey') {
        if (!this.resourceKey) {
          this.$message({
            type: 'info',
            message: 'resourceKey 不能为空～',
          })
          return
        }
        const data = new FormData()
        data.append('key', this.resourceKey)
        refreshResourceKeyResponse(data).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '清除缓存成功～',
            })
          }
        })
      }
    },
  },
}
</script>
